import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const SpaceTrashPortal: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SpaceTrashPortal" */ './SpaceTrashPortal.tsx'))
			.SpaceTrashPortal,
	name: 'SpaceTrashPortal',
});
